import React, { useState, useEffect, Fragment } from 'react'
import { Input, Modal, ModalHeader, ModalBody, Row, Col, FormGroup, Form, Label, Button, ModalFooter } from 'reactstrap'

// Import API config object
import { tokenConfig } from '../../utils/apiConfig'

// Import Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

import axios from 'axios';


const AddEvent = props => {
    //Defining Backend Query
    const [addMode, setAddMode] = useState(false)
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [status, setStatus] = useState('')
    const [location, setLocation] = useState('')
    const [difficulty, setDifficulty] = useState('')
    const [capacity, setCapacity] = useState('')

    //Adding new entry to backend
    const addNewEvent = async e => {
        e.preventDefault()
        const newEvent = {
            name, description, status, location, difficulty, capacity, company_id: "5f44f153841c2929c2eee625"
        }
        await axios.post('/api/events', newEvent, tokenConfig())
            .then(res => {
                props.updateEventList(res.data)
                setAddMode(false)
                setName('')
                setDescription('')
                setStatus('')
                setLocation('')
                setDifficulty('')
                setCapacity('')
            })
            .catch(err => console.log(err.message))
    }

    return (
        <Fragment>
            <span style={{ float: 'right', marginRight: '1rem' }}>
                <FontAwesomeIcon
                    color='blue'
                    style={{ fontSize: "30px", cursor: 'pointer' }}
                    icon={faPlusSquare}
                    onClick={() => setAddMode(true)}
                />
            </span>

            <Modal isOpen={addMode} size='lg' toggle={() => setAddMode(false)}>
                <ModalHeader toggle={() => setAddMode(false)}>Add Event</ModalHeader>
                <Form onSubmit={addNewEvent}>
                    <ModalBody>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Event Name</Label>
                                    <Input type="text" defaultValue={name} onChange={e => setName(e.target.value)} required />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Description</Label>
                                    <Input type="textarea" defaultValue={description} onChange={e => setDescription(e.target.value)} required />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Difficulty</Label>
                                    <Input type="select" defaultValue={difficulty} onChange={e => setDifficulty(e.target.value)} required>
                                        <option></option>
                                        <option>Beginner</option>
                                        <option>Intermediate</option>
                                        <option>Hard</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>Status</Label>
                                    <Input type="select" defaultValue={status} onChange={e => setStatus(e.target.value)} required>
                                        <option></option>
                                        <option>Open</option>
                                        <option>Closed</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Location</Label>
                                    <Input type="text" defaultValue={location} onChange={e => setLocation(e.target.value)} required />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>Capacity</Label>
                                    <Input type="number" defaultValue={capacity} onChange={e => setCapacity(e.target.value)} required />
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button type='submit' color="primary">Create Event</Button>{' '}
                        <Button color="secondary" onClick={() => setAddMode(false)}>Cancel</Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </Fragment>

    )
}

export default AddEvent